import React from 'react';
import { GhostIcon, MessageCircleIcon, TrendingDownIcon, BotIcon } from 'lucide-react';
import { Section } from './shared';
const painCards = [{
  icon: GhostIcon,
  title: "El cliente 'fantasma'",
  text: 'Te hizo laburar 2 horas cotizando un Todo Riesgo y te dejó en visto por $2.000 de diferencia.'
}, {
  icon: MessageCircleIcon,
  title: 'Esclavitud del WhatsApp',
  text: 'Siniestros un sábado a la noche y consultas un domingo al mediodía. No sos dueño de tu tiempo, sos un cadete de tu cartera.'
}, {
  icon: TrendingDownIcon,
  title: 'Inflación vs Comisiones',
  text: 'Laburás el doble para ganar lo mismo que hace 6 meses. Sin escala, tu negocio se achica.'
}, {
  icon: BotIcon,
  title: 'Miedo a la obsolescencia',
  text: 'Ver cómo los brokers digitales te roban clientes porque ellos sí usan tecnología.'
}];
export function Pain() {
  return <div className="w-full bg-navy-deep py-16 text-white sm:py-24" data-id="element-133" data-mp="qf4yasbxpqz7">
      <Section data-id="element-134" data-mp="mcqh0cnwyza1">
        <h2 className="mx-auto max-w-3xl text-center font-display text-2xl font-extrabold leading-tight sm:text-4xl" data-id="element-135" data-mp="mc8nhnsmyz5t">
          ❌ ¿CUÁNTOS DOMINGOS A LAS 11 DE LA NOCHE MÁS VAS A PASAR ASÍ?
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-base text-blue-100/85 sm:text-lg" data-id="element-136" data-mp="23paxb7hu2w4e">
          Estudiaste para vender seguros y asesorar a tus clientes. Terminaste apagando incendios por
          WhatsApp.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-137" data-mp="2ho0qwd5g2do0">
          {painCards.map(({
          icon: Icon,
          title,
          text
        }) => <div key={title} className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm" data-id="element-138" data-mp="2mlj5ok657n3x">
              <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-red-500/15 text-red-300" data-id="element-139" data-mp="28mt68xvupbce">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-140" data-mp="2cqirpeh8bct7" />
              </div>
              <h3 className="font-display text-lg font-bold text-white" data-id="element-141" data-mp="x6me2kdyinrj">{title}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-blue-100/80" data-id="element-142" data-mp="11b2i0g40fl44">{text}</p>
            </div>)}
        </div>

        <div className="mx-auto mt-12 max-w-2xl space-y-2 text-center" data-id="element-143" data-mp="33y95r8jhoksf">
          <p className="text-lg font-semibold text-blue-100" data-id="element-144" data-mp="2yyeev4zprv7d">La IA avanzando… y vos sin sistema.</p>
          <p className="font-display text-xl font-bold text-gold-soft sm:text-2xl" data-id="element-145" data-mp="2u522bt8b7euz">
            No estás atrasado. Estás trabajando con el modelo equivocado.
          </p>
          <p className="text-lg font-semibold text-white" data-id="element-146" data-mp="2l5ykeskvp5i2">
            ¿Y si este fuera el último domingo que pasás así?
          </p>
        </div>
      </Section>
    </div>;
}